// extracted by mini-css-extract-plugin
export default {"root":"PunchupPageContent_root__C62bi"};